module.exports = __webpack_public_path__ + "img/7.16271294.jpg";